<template>

    <div class="alert border-0 text-bg-success position-fixed bottom-0 start-50 translate-middle alert-dismissible fade mb-0" role="alert" style="z-index: 10000000;" :class="{'show': message}">
        <span v-html="message" class=""></span>
        <button type="button" class="btn-close btn-close-white" data-bs-dismiss="alert" aria-label="Close"></button>
    </div>

</template>


<script>
    export default {
        props: [
            'type', // @todo
            'message',
        ],
        data() {
            return {

            }
        }
    }
</script>